module.exports = __webpack_public_path__ + "img/microneedling-user-guide-orange.8c21bc40.svg";